import { Carousel as InnerCarousel, CarouselSlider } from './carousel';
import { useCarousel } from './hooks/use-carousel';
const Carousel = InnerCarousel;
Carousel.useCarousel = useCarousel;
Carousel.Slider = CarouselSlider;
export default Carousel;
